import {useSuiContext} from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const useTracking = () => {
  const {track} = useAnalyticsTrack()
  const {domain, i18n} = useSuiContext()

  const config = domain.get('config')
  const {TRACKING_EVENT_NAMES} = config.get('tracking')
  const {COMPLAINT_TYPES} = config.get('report')

  const trackDrawerFormViewed = async ({adId}) => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      event: TRACKING_EVENT_NAMES.REPORT_AD_VIEWED,
      ad: {id: adId}
    })
    return track(eventData)
  }

  const trackComplaintReasonSelected = async ({adId, complaintTypeId}) => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      event: TRACKING_EVENT_NAMES.REPORT_AD_VIEWED,
      ad: {id: adId},
      complaintReason: i18n.t(COMPLAINT_TYPES[complaintTypeId].text)
    })

    return track(eventData)
  }

  const trackComplaintSent = async ({adId, complaintTypeId}) => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      event: TRACKING_EVENT_NAMES.AD_REPORTED,
      ad: {id: adId},
      complaintReason: i18n.t(COMPLAINT_TYPES[complaintTypeId].text)
    })

    return track(eventData)
  }

  const trackComplaintSendingError = async ({adId, complaintTypeId, errorType}) => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      event: TRACKING_EVENT_NAMES.AD_REPORTED_ERROR,
      ad: {id: adId},
      complaintReason: i18n.t(COMPLAINT_TYPES[complaintTypeId].text),
      errorType
    })

    return track(eventData)
  }

  return {trackDrawerFormViewed, trackComplaintReasonSelected, trackComplaintSent, trackComplaintSendingError}
}

export {useTracking}
